import { ElementProps } from "../../../types/common";

export const ArrowIcon = (props: ElementProps) => (
  <svg
    width={17}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m4.263 15.84 9.116-9.116H6.783l.015-1.727h9.676v9.677h-1.742l.016-6.58-9.116 9.115-1.37-1.369Z"
      fill="#4132EB"
    />
  </svg>
);
